module.exports = __webpack_public_path__ + "static/media/count10_118.94fe985a.png";